import React from 'react';
import { BrainIcon } from 'lucide-react';
type PlayerTabsProps = {
  activeTab: string;
  setActiveTab: (tab: string) => void;
};
const PlayerTabs = ({
  activeTab,
  setActiveTab
}: PlayerTabsProps) => {
  const tabs = [{
    id: 'stats',
    label: 'STATS'
  }, {
    id: 'neuro',
    label: <div className="flex items-center gap-1.5" data-id="element-674">
          <BrainIcon className="w-4 h-4" data-id="element-675" />
          NEURO
        </div>
  }, {
    id: 'charts',
    label: 'CHARTS'
  }, {
    id: 'box_score',
    label: 'BOX SCORE'
  }, {
    id: 'matches',
    label: 'MATCHES'
  }, {
    id: 'team_mates',
    label: 'TEAMMATES'
  }, {
    id: 'notes',
    label: 'NOTES'
  }, {
    id: 'career',
    label: 'CAREERS'
  }, {
    id: 'news',
    label: 'NEWS'
  }];
  return <div className="mt-6 border-b" data-id="element-676">
      <div className="flex" data-id="element-677">
        {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-4 py-2 text-sm font-medium ${activeTab === tab.id ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-678">
            {tab.label}
          </button>)}
      </div>
    </div>;
};
export default PlayerTabs;